import _ from 'lodash'
import i18n from '@/i18n'

export default {
  namespaced: true,

  state: {
    name: null,
    dateTimeZone: null,
    dateTimeCulture: null
  },

  mutations: {
    setData(state, data) {
      _.set(state, 'name', _.get(data, 'name', null))
      _.set(state, 'dateTimeZone', _.get(data, 'dateTimeZone', null))
      _.set(state, 'dateTimeCulture', _.get(data, 'dateTimeCulture', null))
      i18n.locale = _.get(data, 'language', 'en')
    },
    updateBuildingData(state, data) {
      _.set(state, 'dateTimeZone', _.get(data, 'dateTimeZone', null))
      _.set(state, 'dateTimeCulture', _.get(data, 'dateTimeCulture', null))
      i18n.locale = _.get(data, 'language', 'en')
    }
  },

  actions: {
    async load({commit}, data) {
      commit('setData', data)
    },
    updateBuildingData({commit}, data) {
      commit('updateBuildingData', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/flightBoard.js